import { memo } from "react";

import { ExternalLink } from "@/components/ui/button/external-link";

export const ReferenceArticles = memo(() => {
	return (
		<div>
			<ExternalLink
				href="https://chillnn.notion.site/25cfffe15c578085849cd5f05ab3bff2"
				text="マガジンの作成方法"
			/>
		</div>
	);
});

ReferenceArticles.displayName = "ReferenceArticles";
